import { render, staticRenderFns } from "./user-coin.vue?vue&type=template&id=223c6648&scoped=true&"
import script from "./user-coin.vue?vue&type=script&lang=js&"
export * from "./user-coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c6648",
  null
  
)

export default component.exports